import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import pluralize from 'pluralize';
import QuestionsContainer from '../common/QuestionsContainer';
import './InterestInProjectSubmitted.scss';

class InterestInProjectSubmitted extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: true,
      showQuestion: false,
    };

    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleCloseModal(reload) {
    this.setState({ showModal: false });
    if (reload) { window.location.href = `${location.protocol}//${location.host}${location.pathname}`; }
  }

  handleShowQuestion() {
    this.setState({ showQuestion: true });
  }

  renderInterestedCreated(primaryQuestion) {
    const { associations } = this.props;
    return (
      <div className="interest-created-message">
        <h1 className="mt-15 mb-15">Success, resume submitted!</h1>
        <div className="body-text-1">
          You started an application for this project. Clora will follow up with next steps.
        </div>

        {primaryQuestion && associations
          && (
          <div className="profile-completion-suggestion">
            <h4 className="mb-8">{primaryQuestion.question_text}</h4>
            <p className="body-text-2 mb-3 ">
              {associations.length > 1
                ? `Your profile has 0 out of the ${associations.length} ${primaryQuestion.question_text} of this project.  Would you like to complete that information?`
                : `We noticed your profile doesn’t have ${primaryQuestion.question_key === 'stages_of_development' ? associations[0] : associations[0].name} as a ${primaryQuestion.question_text.split(' ').map((w) => pluralize.singular(w)).join(' ')}.  Would you like to add that information?`}
            </p>
            <button
              type="button"
              className="btn btn-primary update-profile-question"
              onClick={() => this.handleShowQuestion()}
            >
              Add
              {' '}
              {primaryQuestion.question_text}
            </button>
          </div>
          )}
      </div>
    );
  }

  render() {
    const { showModal, showQuestion } = this.state;
    const {
      questions, associations, consultantProfileId, csrfToken,
    } = this.props;
    let primaryQuestion = null;
    let associationQuestion = null;
    if (questions) {
      primaryQuestion = questions.find((question) => question.parent_id == null);
      associationQuestion = questions.find((question) => question.association_model !== null);
    }
    return (
      <Modal
        dialogClassName="interest-in-project-submitted style-guide"
        show={showModal}
        onHide={() => this.handleCloseModal()}
      >
        <Modal.Header closeButton className="no-border-bottom" />
        <Modal.Body>
          {showQuestion
            ? (
              <Fragment>
                <QuestionsContainer
                  questionnaireName="Consultant Profile"
                  questionIds={questions.map((q) => q.id)}
                  questionableId={consultantProfileId}
                  questionableType="ConsultantProfile"
                  csrfToken={csrfToken}
                  closeModal={this.handleCloseModal}
                  suggestedAnswers={{ [associationQuestion.question_key]: associations }}
                  saveOnChange
                />
                <div className="text-center">
                  <button
                    className="btn btn-primary save"
                    onClick={() => this.handleCloseModal(true)}
                  >
                    Save
                  </button>
                </div>
              </Fragment>
            )
            : this.renderInterestedCreated(primaryQuestion)}
        </Modal.Body>
      </Modal>
    );
  }
}

InterestInProjectSubmitted.propTypes = {
  questions: PropTypes.shape([]),
  associations: PropTypes.shape([]),
  consultantProfileId: PropTypes.number.isRequired,
  csrfToken: PropTypes.string.isRequired,
};

InterestInProjectSubmitted.defaultProps = {
  questions: [],
  associations: [],
};

export default InterestInProjectSubmitted;
